<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="fa fa-money"></i> Transações em Dinheiro
                <b-button class="btn mr-2 btn-sm btn-primary float-right" @click="showAddCashModal = true">
                <i class="fa fa-plus"></i>
                  Entrada
                </b-button>
            </div>
            <b-card-body>
              <c-table
                  @onPageIndexChanged="onPageIndexChanged"
                  @onExportToExcelClick="exportToExcel"
                  :table-data="result"
                  :loading="loading"
                  :fields="fields"
                  :striped="true"
                  :export-enabled="$auth.isPartner"
                  :actionUri="actionUri"
              ></c-table>
          </b-card-body>
        </b-card>        
        <b-modal
            id="modal-addcash"
            ref="modal"
            title="Adicionar dinheiro"
            @ok="handleOk"
            @hidden="resetModal"
            ok-title="Salvar"
            cancel-title="Cancelar"
            v-model="showAddCashModal"
        >
          <div
              class="alert alert-danger"
              role="alert"
              v-show="cashTransactionModel.hasError"
          >{{cashTransactionModel.errorMessage}}</div>
          <form ref="form" @submit.stop.prevent="handleSubmit">
              <div class="form-row">
                  <div class="col-sm-12">
                      <div class="form-group">
                      <label for="exampleFormControlSelect1">Empresa</label>
                      <select :class="{'custom-select': true}" v-model="cashTransactionModel.sellerId">
                          <option v-for="(s, index) in sellerList" :key="index" :value="s.id">{{s.name}}</option>
                      </select>
                      </div>
                  </div>
              </div>
              <div class="form-row">
                  <div class="col-sm-12">
                      <div class="form-group">
                      <label for="exampleFormControlSelect2">Valor</label>
                      <input type="tel" v-money="money" v-model.lazy="cashTransactionModel.amount" :class="{'form-control': true}" />                        
                      </div>
                  </div>
              </div>
          </form>
        </b-modal>
    </div>
</template>
<script>
import cTable from "../../../components/base/Table.vue";
import transactionService from "../../../services/Transactions/transactionService";
import sellerService from "../../../services/Customer/sellerService";
import reportPage from '../../reports/reportPage';
export default {
  name: "cash-transactions",
  inheritAttrs: false,
  mixins: [reportPage],
  components: {    
    cTable
  },
  data: function () {
    return {
      actionUri: 'reports/cashtransactions',
      cashTransactionModel: {
        sellerId: null,
        amount: 0,
        hasError: false,
        errorMessage: ""
      },
      showAddCashModal: false,
      sellerList: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true
      }
    };
  },
  created() {    
    this.request.origin = 'Cash'
    this.bindTableColumns();    
    this.fetchData(1);
    this.fetchModalData();
  },
  methods: {
    bindTableColumns() {
      this.fields[1].label = 'Data';
      if(this.$auth.isPartner) {
        this.fields.push({ key: "acquirerFeeAmount", label: "Valor Adquire.", sortable: false });
        this.fields.push({ key: "spreadAmount", label: "Spread", sortable: false });
        this.fields.push({ key: "salespersonAmount", label: "Valor Rep.", sortable: false });      
      }
      else if(this.$auth.isFinance) {
        this.fields.push({ key: "acquirerFeeAmount", label: "Valor Adquire.", sortable: false });
        this.fields.push({ key: "salespersonAmount", label: "Valor Rep.", sortable: false });
      }
      this.fields.push({ key: 'transactionActions', label: ''});
    },        
    fetchData(page) {      
      const self = this;
      this.showLoading();
      transactionService
        .findAll(
          this.getRequestParams(),
          page
        )
        .then(
          (response) => {
            if(response.status == 204) {
              self.result = self.getEmptyResult()
            }
            else {
              self.result.data = response.data.data
              let transaction = {}
              for(let i = 0; i <= self.result.data.length - 1; i++) {
                transaction = self.result.data[i]
                transaction.transactionId = transaction.id
                
                transaction.paymentMethodFormatted = `${transaction.paymentMethodTypeName} (${transaction.installmentCount}x) <img width="30px" src="${transaction.paymentMethodImage}" alt="${transaction.paymentMethodName}">`
                transaction.nuPartnerFeeFormatted = `${transaction.fee.toLocaleString('pt-BR', { style: 'decimal' })}% | ${transaction.feeAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`                                                              
              }
              self.result.pageIndex = page
              self.result.rowCount = response.data.total
              self.result.pageSize = 10
            }            
            self.hideLoading();
          },
          () => {
            self.result = self.getEmptyResult();
            self.hideLoading();
          }
        );
    },  
    fetchModalData() {
      const self = this;
      this.showLoading();
      sellerService.all("").then(
        response => {
          self.sellerList = response.status == 204 ? [] : response.data;
          self.sellerList.unshift({ id: null, name: "Selecione" });
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );
    },
    exportToExcel(tableName) {
      const self = this;
      this.showLoading();
      transactionService.findAllExport(this.getRequestParams()).then(
        (response) => {
          window.open(response);
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );      
    },
    fetchModalData() {
      const self = this;
      this.showLoading();
      sellerService.all("").then(
        response => {
          self.sellerList = response.status == 204 ? [] : response.data;
          self.sellerList.unshift({ id: null, name: "Selecione" });
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );
    },
    resetModal() {
      this.cashTransactionModel.sellerId = null;
      this.cashTransactionModel.amount = 0;
      this.cashTransactionModel.hasError = false;
      this.cashTransactionModel.errorMessage = "";
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.cashTransactionModel.errorMessage = "";
      this.cashTransactionModel.hasError = false;
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      const self = this;
      let amountStr = self.cashTransactionModel.amount;
      amountStr = amountStr.replace(".","");
      amountStr = amountStr.replace(",",".");
      let amount = parseFloat(amountStr);
      if(self.cashTransactionModel.sellerId == null) {
        self.cashTransactionModel.errorMessage = "Selecione uma empresa.";
        self.cashTransactionModel.hasError = true;
        return;
      }
      if(amount <= 0) {
        self.cashTransactionModel.errorMessage = "Valor deve ser maior que zero.";
        self.cashTransactionModel.hasError = true;
        return;
      }
      transactionService.addCash(self.cashTransactionModel.sellerId, amount).then(
        response => {
          self.fetchData(1);
          // Hide the modal manually
          self.$nextTick(() => {
            self.$refs.modal.hide();
          });
        },
        error => {
          self.cashTransactionModel.errorMessage =
            "Ocorreu um erro ao adicionar dinheiro";
          self.cashTransactionModel.hasError = true;
        }
      );
    } 
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>